import { render, staticRenderFns } from "./EventChoice.vue?vue&type=template&id=4cdc7ca6&scoped=true&"
import script from "./EventChoice.vue?vue&type=script&lang=ts&"
export * from "./EventChoice.vue?vue&type=script&lang=ts&"
import style0 from "./EventChoice.vue?vue&type=style&index=0&id=4cdc7ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc7ca6",
  null
  
)

export default component.exports